import { render, staticRenderFns } from "./lahi-loader.vue?vue&type=template&id=5b078f60&lang=pug&functional=true"
var script = {}
import style0 from "./lahi-loader.vue?vue&type=style&index=0&id=5b078f60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports